import { useCallback } from 'react';

import type { DialogAnalyticsParams, DialogId, DialogType, TouchpointIntent } from './types';
import { useAnalytics } from './use-analytics';

type useOnDismissDialogProps = DialogAnalyticsParams & {
	touchpointIntent?: TouchpointIntent;
	dialogType?: DialogType;
	dialogId?: DialogId;
	onClose?: () => void;
};

/**
 * Given `touchpointIntent` `dialogType` `dialogId` will
 * return a callback which fires an editionAwarenessDialogDismissed button clicked event
 */
export const useOnDismissDialog = ({
	touchpointIntent,
	dialogType,
	dialogId,
	attributes,
	onClose,
}: useOnDismissDialogProps) => {
	const { sendAnalyticsEvent } = useAnalytics();

	return useCallback(() => {
		sendAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'editionAwarenessDialogDismissed',
			attributes: {
				touchpointIntent,
				dialogType,
				dialogId,
				...attributes,
			},
		});
		onClose && onClose();
	}, [sendAnalyticsEvent, touchpointIntent, dialogType, dialogId, attributes, onClose]);
};
